import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import FJActionHeadshotGenerator from '../../../../redux/action/FJActionHeadshotGenerator';
import FJHeadshotHistory from '../view/FJHeadshotHistory';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionCommon from '../../../../redux/action/FJActionCommon';
import FJKeymap from '../../../../util/FJKeymap';
import FJAppConstant from '../../../../constants/FJAppConstant';

const FJHeadshotHistoryContainer = ({ active }) => {
    const dispatch = useDispatch();
    useLocalStore();

    // 从 Common 获取状态
    const historyList = useSelector(state => state.common.historyList);
    const selectList = useSelector(state => state.common.selectList);
    const isMultipleMode = useSelector(state => state.common.isMultipleMode);
    const historyListStatus = useSelector(state => state.common.historyListLoadStatus);

    const handleItemDelete = useCallback(
        id => {
            dispatch(FJActionCommon.multiDeleteAction([id], undefined, { type: FJAppConstant.HEADSHOT_GENERATOR }));
        },
        [dispatch],
    );

    const handleGetStarted = useCallback(() => {
        dispatch(FJActionHeadshotGenerator.changeTabIndexAction(0));
    }, [dispatch]);

    const setSelectList = useCallback(
        value => {
            dispatch(FJActionCommon.setSelectListAction(value));
            if (value.length === 0) {
                dispatch(FJActionCommon.setIsMultipleModeAction(false));
            }
        },
        [dispatch],
    );

    const multiDelete = useCallback(
        ids => {
            dispatch(
                FJActionCommon.multiDeleteAction(
                    ids,
                    () => {
                        dispatch(FJActionCommon.setIsMultipleModeAction(false));
                        dispatch(FJActionCommon.setSelectListAction([]));
                    },
                    { type: FJAppConstant.HEADSHOT_GENERATOR },
                ),
            );
        },
        [dispatch],
    );

    const clearSelected = useCallback(() => {
        dispatch(FJActionCommon.setIsMultipleModeAction(false));
    }, [dispatch]);

    const handleDownload = useCallback(
        ids => {
            dispatch(FJActionHeadshotGenerator.onDownloadCollectionAction(ids));
        },
        [dispatch],
    );

    const _keyDown = useCallback(
        e => {
            if (e.code === 'Escape') {
                if (FJKeymap.getScope() === 'default') {
                    setSelectList([]);
                    dispatch(FJActionCommon.setIsMultipleModeAction(false));
                }
            }
        },
        [dispatch, setSelectList],
    );

    useEffect(() => {
        window.addEventListener('keydown', _keyDown);
        return () => {
            window.removeEventListener('keydown', _keyDown);
        };
    }, [_keyDown, isMultipleMode]);

    return (
        <FJHeadshotHistory
            onItemDelete={handleItemDelete}
            onGetStarted={handleGetStarted}
            historyList={historyList}
            historyListStatus={historyListStatus}
            selectList={selectList}
            isMultipleMode={isMultipleMode}
            setSelectList={setSelectList}
            multiDelete={multiDelete}
            clearSelected={clearSelected}
            onDownload={handleDownload}
            active={active}
        />
    );
};

FJHeadshotHistoryContainer.propTypes = {
    active: PropTypes.bool,
};

export default FJHeadshotHistoryContainer;
